import Header from "@/components/header";
import { Sidebar, SidebarProvider } from "@/components/sidebar";
import { cn } from "@/utils";
import { orpc } from "@/utils/clients/orpc";
import { CONSTANTS } from "@/utils/constants";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import * as z from "zod";
import { ReservationDrawer } from "./-reservations/-drawer/-index";

export const Route = createFileRoute("/_authenticated")({
  component: Component,
  validateSearch: z.object({
    reservationId: z.string().optional(),
    paymentId: z.string().optional(),
  }),
  beforeLoad: async ({ context }) => {
    const data = await context.queryClient.ensureQueryData(orpc.auth.getAuth.queryOptions());

    if (!data) throw redirect({ to: "/login" });
    context.posthog.identify(data.user.id, {
      ...data.user,
      type: data.userType,
    });

    if (!data.user.agencyId) throw redirect({ to: "/onboarding" });
    context.posthog.group("agency", data.user.agencyId);

    return { auth: data };
  },
  loaderDeps: ({ search }) => [search.reservationId],
  loader: async ({ context, deps: [reservationId] }) => {
    if (reservationId) {
      void context.queryClient.prefetchQuery(
        orpc.reservation.get.queryOptions({
          input: { type: "reservationId", value: reservationId },
        }),
      );
    }
  },
});

function Component() {
  return (
    <SidebarProvider>
      <div className="flex min-h-svh grow flex-col md:flex-row">
        <Sidebar />
        <div className={cn("relative flex min-w-0 grow flex-col", CONSTANTS.DEMO ? "pt-26.75" : "pt-14.75")}>
          <Header />
          <main className="p-md md:p-lg flex grow flex-col">
            <Outlet />
            <ReservationDrawer />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
